import { useState } from "react";
import styles from "../../../styles/patient-page-modules/Notes.module.css";
import { Dropdown, DropdownItem } from "../../ui/dropdown";

const sortOptions = [
  { value: "latest", label: "Latest" },
  { value: "oldest", label: "Oldest" },
];

const NotesControls = ({ handleSort, defaultSort = "latest" }) => {
  const [filter, setFilter] = useState(defaultSort);

  const activeLabel =
    sortOptions.find((o) => o.value === filter)?.label || "Latest";

  return (
    <Dropdown
      options={sortOptions}
      value={filter}
      onChange={(value) => {
        setFilter(value);
        handleSort(value);
      }}
      trigger={
        <button type="button" className={styles.sortTrigger}>
          <span>{activeLabel}</span>
          <svg
            className={styles.sortChevron}
            viewBox="0 0 12 12"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M3 4.5L6 7.5L9 4.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      }
    >
      {sortOptions.map((opt) => (
        <DropdownItem key={opt.value} value={opt.value}>
          {opt.label}
        </DropdownItem>
      ))}
    </Dropdown>
  );
};

export default NotesControls;
